import type { Recording } from './types';

type RecordingPlayerProps = {
  recording: Recording;
};

const RecordingPlayer = ({ recording }: RecordingPlayerProps) => {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-2">
        <div className="flex items-center justify-between">
          <h2 className="text-[16px] font-bold text-slate-900">{recording.title}</h2>
          <div className="flex items-center gap-2">
            {/* <button className="flex items-center gap-2 text-slate-400 hover:text-slate-600">
              <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
              </svg>
              <span className="text-sm">Export</span>
            </button> */}
          </div>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-[12px] font-medium text-slate-500">{recording.coach_name}</span>
          <span className="h-1 w-1 rounded-full bg-slate-300"></span>
          <span className="text-[12px] text-slate-500">
            {new Date(recording.date).toLocaleDateString('en-US', {
              month: 'short',
              day: 'numeric',
              year: 'numeric',
            })}
          </span>
          <span className="rounded-[6px] bg-emerald-100 px-2 py-1 text-[12px] font-bold text-emerald-700 uppercase tracking-wider">
            {recording.status}
          </span>
        </div>
      </div>

      <div className="relative aspect-video w-full overflow-hidden rounded-[6px] group">
        <video
          className="h-full w-full object-contain"
          controls
          poster={recording.thumbnail_url}
        >
          <source src={recording.recording_url} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* Placeholder for "SJ" initials shown in UI if no thumbnail or just decorative */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <div className="h-24 w-24 rounded-full bg-indigo-600/90 flex items-center justify-center text-white text-4xl font-bold shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            SJ
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecordingPlayer;
